import {
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import logo1 from "../assets/logo1.png";
export default function Sidebar() {
  const navigate = useNavigate();

  const location = useLocation();

  const logout = () => {
    localStorage.removeItem("token");

    navigate("/");
  };

  const menuItems = [
    {
      name: "Create Campaign",
      path: "/create-campaign",
      // icon: "📢",
    },

    // Future Ready
    // {
    //   name: "Campaign History",
    //   path: "/campaign-history",
    //   icon: "📜",
    // },

    // {
    //   name: "Analytics",
    //   path: "/analytics",
    //   icon: "📊",
    // },
  ];

  return (
    <div className="h-screen w-72 bg-white border-r border-gray-200 fixed left-0 top-0 flex flex-col justify-between shadow-sm">

      {/* Top Section */}
      <div>
        {/* Branding */}
        <div className="px-6 py-6 border-b border-gray-100">
          <div className="flex items-center gap-4">

            <div className="w-14 h-14 rounded-2xl bg-black text-white flex items-center justify-center text-2xl font-bold shadow-sm">
              S
            </div>

            <div>
              <h1 className="text-2xl font-bold text-gray-900 leading-tight">
                WA Scheduler
              </h1>

              <p className="text-sm text-gray-500 mt-1">
                Campaign Manager
              </p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="p-4 space-y-3">
          {menuItems.map((item, index) => (
            <Link
              key={index}
              to={item.path}
              className={`flex items-center gap-3 px-5 py-4 rounded-2xl transition-all duration-200 font-medium ${
                location.pathname === item.path
                  ? "bg-black text-white shadow-sm"
                  : "bg-gray-100 text-gray-700 hover:bg-black hover:text-white"
              }`}
            >
              <span className="text-lg">
                {item.icon}
              </span>

              <span>{item.name}</span>
            </Link>
          ))}
        </div>
      </div>

      {/* Bottom Section */}
      <div className="p-5 border-t border-gray-100">
        
        {/* Powered By */}
        <div className="bg-gray-50 rounded-2xl p-4 mb-4">
          <p className="text-xs uppercase tracking-wide text-gray-400 mb-2">
            Powered By
          </p>

          <div className="flex items-center gap-3">
            
            <div className="w-12 h-12 flex items-center justify-center">
  <img
    src={logo1}
    alt="Synoweb Logo"
    className="w-full h-full object-contain"
  />
</div>

            <div>
              <p className="font-semibold text-gray-800">
                SynowebTech
              </p>

              <p className="text-xs text-gray-500">
                WhatsApp Solutions
              </p>
            </div>
          </div>
        </div>

        {/* Logout */}
        <button
          onClick={logout}
          className="w-full bg-red-500 hover:bg-red-600 transition-all text-white py-3 rounded-2xl font-medium"
        >
          Logout
        </button>
      </div>
    </div>
  );
}